import { SVGFC } from '@repo/toolkit/types'

const CalendarFiveIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.163 6.69753C19.163 5.35504 18.3455 4.20752 17.183 3.71254C16.8005 3.54752 16.373 3.45752 15.923 3.45752H15.1205V5.43002C15.1205 5.84251 14.7905 6.18002 14.3705 6.18002C13.958 6.18002 13.6205 5.84251 13.6205 5.43002V3.45752H7.043V5.43002C7.043 5.84251 6.70549 6.18002 6.293 6.18002C5.88051 6.18002 5.543 5.84251 5.543 5.43002V3.45752H4.74049C3.623 3.45752 2.6405 4.02753 2.05548 4.89005C1.703 5.40755 1.50049 6.03001 1.50049 6.69753V7.19255H19.163V6.69753Z"
        fill={color}
      />
      <path
        d="M4.74049 19.9053H11.483C10.913 18.9228 10.583 17.7754 10.583 16.5529C10.583 12.8479 13.5905 9.84035 17.288 9.84035C17.9405 9.84035 18.5705 9.93034 19.163 10.1028V8.69287H1.50049V16.6728C1.50049 18.4578 2.95549 19.9053 4.74049 19.9053Z"
        fill={color}
      />
      <path
        d="M7.04297 2.99268C7.04297 2.58018 6.70546 2.24268 6.29297 2.24268C5.88048 2.24268 5.54297 2.58018 5.54297 2.99268V3.45767H7.04297V2.99268Z"
        fill={color}
      />
      <path
        d="M15.1201 2.99268C15.1201 2.58018 14.7901 2.24268 14.3701 2.24268C13.9576 2.24268 13.6201 2.58018 13.6201 2.99268V3.45767H15.1201V2.99268Z"
        fill={color}
      />
      <path
        d="M17.288 11.3398C14.4155 11.3398 12.083 13.6798 12.083 16.5524C12.083 19.4249 14.4155 21.7574 17.288 21.7574C20.1605 21.7574 22.5005 19.4249 22.5005 16.5524C22.5005 13.6798 20.1605 11.3398 17.288 11.3398ZM19.898 15.7273L17.2355 18.3899C17.0855 18.5398 16.898 18.6073 16.703 18.6073C16.5155 18.6073 16.3205 18.5398 16.1705 18.3899L14.6555 16.8748C14.363 16.5823 14.363 16.1098 14.6555 15.8174C14.9555 15.5249 15.428 15.5249 15.7205 15.8174L16.703 16.7999L18.8405 14.6698C19.133 14.3773 19.6055 14.3773 19.898 14.6698C20.1905 14.9624 20.1905 15.4349 19.898 15.7273Z"
        fill={color}
      />
    </svg>
  )
}

export default CalendarFiveIcon
